import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/169/components/features/cases/OldComponents/cases/skolkovo-kids/index.js");
